const defaultConfig = {
  appVersion: '6.2.18',
  appPlatformVersion: '4.7.6'
}
export default defaultConfig
